// ==============================================
// ==================Import======================
// ==============================================

// ==================React Hook===================
import { useDispatch, useSelector } from 'react-redux';
import {
  useEffect, useMemo, useCallback, useRef,
} from 'react';

// ==================AgGrid===================
import { AgGridReact } from 'ag-grid-react';

// ==================Style&IMG===================
import './style.scss';

// ==================Actions===================
import { setNetworkGrid, setSaveMarkerSelected } from '../../../actions/network';
import { saveStringToClipboard } from '../../../actions/site';

// ==================Components===================
import linkMarker from '../../Site/DataGrid/linkMarker';
import { setBtnExport } from '../../../actions/menuButton';

function GridNetwork() {
  // ==================HOOK=========================
  const networkGrid = useSelector((state) => state.network.networkArray);
  const loading = useSelector((state) => state.site.dataGrid.loadingDataGrid);
  const dispatch = useDispatch();
  const rows = useSelector((state) => state.network.networkGrid);
  const rowMarkerSelected = useSelector((state) => state.network.rowMarkerSelected);
  const btnExport = useSelector((state) => state.menuButton.btnExport);

  // ============== UseMemo ========================
  const defaultColDef = useMemo(() => ({
    flex: 1,
    minWidth: 100,
    sortable: true,
    resizable: true,
  }), []);

  // ================= Refs =========================
  const gridRef = useRef();

  // definition of columns params
  const columns = [
    {
      field: 'marker',
      headerName: 'Marker',
      minWidth: 200,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      cellRenderer: linkMarker,
    },
    {
      field: 'site',
      headerName: 'Site Name',
      suppressMenu: true,
    },
    {
      field: 'installDate',
      headerName: 'Install Date',
    },
    {
      field: 'endDate',
      headerName: 'End Date',
    },
    {
      field: 'lat',
      headerName: 'Latitude',
    },
    {
      field: 'lon',
      headerName: 'Longitude',
    },
    {
      field: 'alt',
      headerName: 'Altitude',
    },
    {
      field: 'country',
      headerName: 'Country',
    },
  ];

  // function allowing you to save the selected lines in the clipboard so you can copy them later
  const onSelectionChanged = useCallback((event) => {
    const rowSelected = event.api.getSelectedNodes();
    const rowSelectedArray = [];
    rowSelected.map((el) => rowSelectedArray.push(el.data.marker));
    dispatch(setSaveMarkerSelected(rowSelectedArray));
    const filesSelect = event.api.getSelectedNodes();
    const filesSelectedArray = [];
    filesSelect.map((el) => filesSelectedArray.push(el.data));
    let stringToClipboard = '';
    filesSelectedArray.map((obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        stringToClipboard += `${key}: ${value}, `;
      });
      return stringToClipboard;
    });
    if (filesSelectedArray.length > 0) {
      dispatch(saveStringToClipboard(stringToClipboard));
    }
    else {
      dispatch(saveStringToClipboard(''));
    }
  }, []);

  // ================= Functions =========================
  // creating a data table for each row of the grid
  function rowsDataGrid() {
    const rowsDataNetworkGrid = [];
    if (networkGrid.length !== 0) {
      for (let i = 0; i <= networkGrid.length - 1; i += 1) {
        const dataGridRow = {
          id: i,
          marker: networkGrid[i].marker_long_name,
          site: networkGrid[i].name,
          installDate: networkGrid[i].date_from,
          endDate: networkGrid[i].date_to,
          lat: networkGrid[i].location.coordinates.lat,
          lon: networkGrid[i].location.coordinates.lon,
          alt: networkGrid[i].location.coordinates.altitude,
          country: networkGrid[i].location.country.name,
        };
        rowsDataNetworkGrid.push(dataGridRow);
      }
    }
    dispatch(setNetworkGrid(rowsDataNetworkGrid));
  }

  // ================= useEffect ======================
  // function to create and save in the state the object containing the grid lines
  useEffect(() => {
    if (networkGrid.length > 0) {
      rowsDataGrid();
    }
  }, [loading, networkGrid]);

  // function allowing you to launch the csv export of the selected lines, all lines by default
  useEffect(() => {
    if (btnExport === true) {
      if (rowMarkerSelected.length === 0) {
        gridRef.current.api.exportDataAsCsv();
      }
      else if (rowMarkerSelected.length > 0) {
        gridRef.current.api.exportDataAsCsv({ onlySelected: true });
      }
      dispatch(setBtnExport(false));
    }
  }, [btnExport]);
  return (
    <>
      <div className="ag-theme-alpine network--grid--div">
        <AgGridReact
          ref={gridRef}
          className="dataGrid"
          columnDefs={columns}
          rowData={rows}
          defaultColDef={defaultColDef}
          rowSelection="multiple"
          onSelectionChanged={onSelectionChanged}
        />
      </div>
      <div className="totalItems">Total Stations: {networkGrid.length} {((rowMarkerSelected.length > 0) && (rowMarkerSelected[0] !== undefined)) && ` (selected station(s): ${rowMarkerSelected.length})`}</div>
    </>
  );
}

export default GridNetwork;
